export const SITE = {
  name: 'NioDelta',
  tagline: 'Crafted, not templated.',
  email: 'hello@niodelta.studio',
  whatsapp: 'https://wa.me/+919067820204',
  location: 'Pune · Bengaluru · Remote',
  socials: [
    { label: 'WhatsApp', href: 'https://wa.me/+919067820204' },
    { label: 'Instagram', href: 'https://instagram.com/niodelta' },
    { label: 'LinkedIn', href: 'https://linkedin.com/company/niodelta' },
    { label: 'X / Twitter', href: 'https://x.com/niodelta' },
    { label: 'Dribbble', href: 'https://dribbble.com/niodelta' },
  ],
};

export const SERVICES = [
  {
    slug: 'website-development',
    num: '01',
    title: 'Website Development',
    short: 'Marketing sites that convert visitors into pipeline.',
    long: 'Hand-built marketing sites and content platforms with fast load, intentional motion, and editorial typography. Built on modern stacks—React, Next.js, Astro—shipped headless when it matters.',
    deliverables: ['Design system', 'CMS-ready pages', 'SEO foundation', 'Analytics & A/B'],
    accent: '#6C5CE7',
  },
  {
    slug: 'web-app-development',
    num: '02',
    title: 'Web App Development',
    short: 'Dashboards, portals and tools that feel inevitable.',
    long: 'From auth to async workflows, we engineer reliable web apps. TypeScript, FastAPI, Postgres / Mongo, and queue-driven backends with proper observability.',
    deliverables: ['Auth & RBAC', 'Realtime data', 'Admin panels', 'API design'],
    accent: '#4B9FFF',
  },
  {
    slug: 'mobile-app-development',
    num: '03',
    title: 'Mobile App Development',
    short: 'Native-feel iOS and Android, one codebase.',
    long: 'React Native and Expo apps with native modules where it counts. Offline-first sync, push, in-app payments and shipping to both stores in weeks—not quarters.',
    deliverables: ['iOS + Android', 'Push notifications', 'Offline sync', 'Store submission'],
    accent: '#6C5CE7',
  },
  {
    slug: 'customer-solutions-development',
    num: '04',
    title: 'Customer Solutions Development',
    short: 'Bespoke internal tools that pay for themselves.',
    long: 'Custom software glued to the way your team actually works. Quoting tools, CRM extensions, ops dashboards, billing flows—built once, owned forever.',
    deliverables: ['Workflow audit', 'Integration layer', 'Internal tooling', 'Hand-off & training'],
    accent: '#4B9FFF',
  },
  {
    slug: 'ecommerce-website-development',
    num: '05',
    title: 'Ecommerce Website Development',
    short: 'Storefronts engineered for AOV and repeat purchase.',
    long: 'Shopify Hydrogen, Medusa or custom headless—built around your catalog, your margins, and your post-purchase loop. From PDP to checkout to ops.',
    deliverables: ['Headless storefront', 'Payments & GST', 'Catalog architecture', 'Retention loops'],
    accent: '#6C5CE7',
  },
  {
    slug: 'ai-solutions',
    num: '06',
    title: 'AI Solutions',
    short: 'Production AI: RAG, agents, automation that ships.',
    long: 'We integrate LLMs into real product surfaces—search, support, content ops, agents. Eval harnesses, guardrails, cost ceilings, observability. Not a demo.',
    deliverables: ['RAG / search', 'Agentic workflows', 'Evals & guardrails', 'Cost & latency budgets'],
    accent: '#4B9FFF',
  },
];

export const WORK = [
  {
    slug: 'kaveri-finserve',
    name: 'Kaveri Finserve',
    sector: 'Lending · Fintech',
    year: '2025',
    summary: 'Re-engineered the loan origination journey for a Pune-based NBFC. 12-step paper trail became a 4-screen guided flow.',
    stat: { kpi: '−47%', label: 'avg. time to disburse' },
    services: ['Web App Development', 'Customer Solutions'],
    palette: ['#6C5CE7', '#0A0A0F'],
  },
  {
    slug: 'baazaarx',
    name: 'BaazaarX',
    sector: 'D2C · Ecommerce',
    year: '2025',
    summary: 'Headless Shopify storefront for a 40-SKU artisan home brand. Editorial PDPs, predictive cart, vernacular checkout.',
    stat: { kpi: '+32%', label: 'AOV in 90 days' },
    services: ['Ecommerce', 'Website Development'],
    palette: ['#4B9FFF', '#0A0A0F'],
  },
  {
    slug: 'vedaa-ai',
    name: 'Vedaa AI',
    sector: 'B2B SaaS · AI',
    year: '2024',
    summary: 'A clinical-grade RAG copilot for Ayurvedic practitioners. Citation-first answers across 1,400 pages of formulary.',
    stat: { kpi: '92%', label: 'answer accuracy on eval set' },
    services: ['AI Solutions', 'Web App Development'],
    palette: ['#6C5CE7', '#4B9FFF'],
  },
  {
    slug: 'aarohan-logistics',
    name: 'Aarohan Logistics',
    sector: 'Logistics · SaaS',
    year: '2024',
    summary: 'A driver-first mobile app and fleet console for a Tier-2 hauler. Routing, ePOD, fuel reconciliation in one app.',
    stat: { kpi: '14k', label: 'consignments tracked / mo' },
    services: ['Mobile App', 'Customer Solutions'],
    palette: ['#4B9FFF', '#0A0A0F'],
  },
  {
    slug: 'chaitanya-edu',
    name: 'Chaitanya Edu',
    sector: 'EdTech · K-12',
    year: '2024',
    summary: 'Live-class platform for a Pune chain of tutorials. 2,800 concurrent students, sub-300ms join, parent-side reports.',
    stat: { kpi: '2.8k', label: 'concurrent students' },
    services: ['Web App Development', 'Mobile App'],
    palette: ['#6C5CE7', '#0A0A0F'],
  },
  {
    slug: 'mithila-textiles',
    name: 'Mithila Textiles',
    sector: 'Heritage · Ecommerce',
    year: '2023',
    summary: 'A flagship for a 4-generation weaving house. Loom-to-cart provenance, slow-scroll storytelling, Hindi + EN.',
    stat: { kpi: '×3.6', label: 'session duration vs. old site' },
    services: ['Website Development', 'Ecommerce'],
    palette: ['#4B9FFF', '#6C5CE7'],
  },
];

export const PROCESS = [
  { step: '01', title: 'Discover', body: 'A focused two-week sprint. We sit with your team, founder, your numbers. We leave with a brief that is honest about scope.' },
  { step: '02', title: 'Define', body: 'Information architecture, key flows, a system of tokens, a motion language. Decisions get documented—designers and engineers stay in sync.' },
  { step: '03', title: 'Design', body: 'Wireframes graduate to high-fidelity in one continuous file. No giant decks. Real components, real states, real copy.' },
  { step: '04', title: 'Build', body: 'Engineering joins on day one. Performance budgets, accessibility, observability are not bolted on—they are the work.' },
  { step: '05', title: 'Ship & extend', body: 'We launch in weeks, not quarters. Then we stay—as a fractional product partner or for the next chapter.' },
];

export const STATS = [
  { kpi: '47', suffix: '+', label: 'shipped products' },
  { kpi: '8', suffix: ' yrs', label: 'compounded craft' },
  { kpi: '12', suffix: '', label: 'in-house operators' },
  { kpi: '4.9', suffix: '/5', label: 'partner NPS' },
];

export const CLIENTS = [
  'Kaveri Finserve', 'BaazaarX', 'Vedaa AI', 'Aarohan Logistics',
  'Chaitanya Edu', 'Mithila Textiles', 'Saraya Bio', 'Bharati Group',
  'Indus Roastery', 'Neelam Hospitality', 'Patanjal Studio', 'Konark Labs',
];
